export default {"src":"/_next/static/media/cross.c23b62b8.svg","height":490,"width":490,"blurWidth":0,"blurHeight":0};